export const HOME_REQUEST = "HOME_REQUEST";
export const HOME_SUCCESS = "HOME_SUCCESS";
export const HOME_FAILURE = "HOME_FAILURE";
